import api from '@/utils/api';

export default {

     async getContents( accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get('/content', {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do content:', error);
            throw error;
        }
    },
    async createContent( accessToken ,payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/content`, payload, {
                method: 'POST',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao criar content:', error);
            throw error;
        }
    },
    async editContent( accessToken ,payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.put(`/content`, payload, {
                method: 'PUT',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao ataulizar o content:', error);
            throw error;
        }
    },
    async getWebsite( accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get('/website', { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do site:', error);
            throw error;
        }
    },
    async updateWebsite( accessToken, id, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.put(`/website/${id}`, payload, { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar dados do site:', error);
            throw error;
        }
    }
}